import { useCallback, useContext, useMemo } from "react";
import { debounce } from "lodash";
import TechpackItem from "../TechpackItem/TechpackItem";
import TechpackService from "../../service/TechpackService";
import { Box } from "../../common/components";

import TechpackItemNavigator from "./TechpackItemNavigator";
import ProjectService from "../../service/ProjectService";
import { AdminTechpackContext } from "../../context/Admin/Techpack";

const AdminTechpack = () => {
  const { teckpackDetails, updateTechpack } = useContext(AdminTechpackContext);
  // const [isAutomaticallyUpdateAllSkus, setIsAutomaticallyUpdateAllSkus] =
  //   useState(true);

  const isProjectStillExists = useMemo(async () => {
    try {
      const res = await ProjectService.getProject(
        teckpackDetails?.techpackitems[0].purchaseddesign.originalProjectId ??
          ""
      );
      return res.status === 200;
    } catch (error) {
      return false;
    }
  }, [teckpackDetails?.techpackitems]);

  /**
   *
   */
  const onProjectNumberChange = useCallback(
    async (value: string) => {
      const saveProject = debounce(
        async (value: string) => {
          const newProjectNumber = value || ""; //Null should be ""

          const data = {
            techpackId: teckpackDetails?.id,
            projectNumber: newProjectNumber,
          };
          await TechpackService.setProjectNumber(data);
          if (teckpackDetails) {
            updateTechpack({
              ...teckpackDetails,
              projectNumber: newProjectNumber,
            });
          }
        },
        100,
        { leading: true }
      );

      //TODO: to do once we have the new sku system
      // if (isAutomaticallyUpdateAllSkus) {
      //   await TechpackService.updateAllSkus(techpackDetail.id);
      // }

      await saveProject(value);
    },
    [teckpackDetails, updateTechpack]
  );

  const onCustomerChange = useCallback(
    async (value: string) => {
      const saveCustomerNumber = debounce(
        async (value: string) => {
          const newCustomerNumber = value || ""; //Null should be ""

          const data = {
            techpackId: teckpackDetails?.id,
            customerNumber: newCustomerNumber,
          };
          await TechpackService.setCustomerNumber(data);
          if (teckpackDetails) {
            updateTechpack({
              ...teckpackDetails,
              customerNumber: newCustomerNumber,
            });
          }
        },
        100,
        { leading: true }
      );

      await saveCustomerNumber(value);
    },
    [teckpackDetails, updateTechpack]
  );

  return (
    <Box display={"flex"} gap={"24px"}>
      <TechpackItemNavigator
        items={teckpackDetails?.techpackitems || []}
        containerId="admin-container"
        projectNumber={teckpackDetails?.projectNumber}
        customerNumber={teckpackDetails?.customerNumber}
        onProjectNumberChange={onProjectNumberChange}
        onCustomerChange={onCustomerChange}
      />
      <Box
        className="techpack-container"
        sx={{
          flex: 1,
          minHeight: 0,
          paddingRight: "72px",
        }}
      >
        <Box gap={"48px"} display={"flex"} flexDirection={"column"}>
          {teckpackDetails?.techpackitems
            .sort((a, b) => {
              // First sort by factory
              if (a.factory !== b.factory) {
                return a.factory.localeCompare(b.factory);
              }
              // Then sort by factory position
              return a.factoryPosition - b.factoryPosition;
            })
            .map((techpackItem, techpackItemIndex) => (
              <Box
                key={techpackItem.id}
                id={`techpack-item-${techpackItem.id}`}
              >
                <TechpackItem
                  isProjectStillExists={isProjectStillExists}
                  techpackId={teckpackDetails?.id || ""}
                  techpackItem={techpackItem}
                  techpackItemIndex={
                    techpackItemIndex + 1 /* Because we start at 1, not 0 */
                  }
                  techpackitemsCount={teckpackDetails.techpackitems.length}
                  orderId={teckpackDetails.orderId} //Needed for the edit of items
                  orderType={teckpackDetails.orderType} //Needed for the edit of items
                />
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminTechpack;
